import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RewardsProgramEffects } from './store/effects/rewards_program_preference.effect';
import { rewardsProgramPreferenceReducer } from './store/reducers/rewards-program-preference.reducer';
import { rewardsProgramReducer } from './store/reducers/rewards-program.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('rewardsProgram', rewardsProgramReducer),
    StoreModule.forFeature(
      'rewardsProgramPreference',
      rewardsProgramPreferenceReducer,
    ),
    EffectsModule.forFeature([RewardsProgramEffects]),
  ],
})
export class RewardsProgramModule {}
